import React, { useState } from 'react'
import {
  Card,
  Table,
  Button,
  Input,
  Divider,
  Collapse,
  Row,
  Col,
  Modal,
  Form,
  Tooltip,
  message,
  Spin,
  Tag,
  Select,
  Switch,
  Checkbox
} from 'antd'
import ProductBrandPic from '../../../assets/images/setUpPayments.png'
import IntlMessages from '../../../util/IntlMessages'
import ds from '../../../Services/DataServices'
import Skeleton from 'react-loading-skeleton'
import AddPrinters from '../../../components/AddPrinters'
import { useHistory } from 'react-router-dom'
import { IntlProvider } from 'react-intl'
import { useStore, useDispatch, useSelector } from 'react-redux'
import { loadData } from '../../../appRedux/actions/Setting'
import { userLogOut } from '../../../appRedux/actions/Auth'
import { setCommonConfigs } from '../../../appRedux/actions/CommonData'
import { PRINTING } from '../../../constants/Pages'
import {
  isEmptyObject,
  checkRightspermissions,
  notAllowMsgCheck
} from '../../../appRedux/actions/GlobalMethods'
import { BEHAVIOUR_TYPE } from '../../../Services/DataServices'
import {
  PRINTING_TYPE,
  PrintCheckDatetime,
  PrintCheckOutlet,
  PrintCheckRegister,
  PrintCheckServedBy,
  PrintShowFooter,
  PrintShowHeader,
  ShowPrinterProds
} from '../../../constants/StoreSetting'
import { checkIsWeb, postDataToApp } from '../../../appRedux/actions/MobAppFn'
import { PostAppTypes } from '../../../constants/MobAppConstants'
import NotAllowedComponent from '../../../components/NotAllowedComponent'

const Panel = Collapse.Panel
const confirm = Modal.confirm

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
    md: { span: 24 }
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
    md: { span: 24 }
  }
}

const CheckboxGroup = Checkbox.Group
const plainOptions = [
  PrintCheckServedBy,
  PrintCheckDatetime,
  PrintCheckOutlet,
  PrintCheckRegister,
  PrintShowHeader,
  PrintShowFooter,
  ShowPrinterProds
]

const PrintListing = ({ match }) => {
  const store = useStore()
  const dispatch = useDispatch()
  const history = useHistory()
  const [form] = Form.useForm()

  const getReduxCommonSetting = useSelector(
    ({ commonConfigs }) => commonConfigs.pageCommonConfigs
  )

  const [getPrintID, setPrintID] = React.useState(0)
  const [confirmLoading, setConfirmLoading] = React.useState(false)
  const [visible, setVisible] = React.useState(false)
  const [isLoading, setIsLoading] = React.useState(true)
  const [isLoadingTable, setIsLoadingTable] = React.useState(false)
  const [getTableData, setTableData] = React.useState([])
  const [isSpinningLoading, setSpinningLoading] = React.useState(false)
  const [loadDataState, setloadDataState] = useState(false)
  const [getPagination, setPagination] = React.useState({
    CurrentPageNo: 1,
    PageSize: 10,
    showSizeChanger: true
  })
  const [getIsDisableCreate, setIsDisableCreate] = useState(true)
  const [getIsDisableUpdate, setIsDisableUpdate] = useState(true)
  const [getIsDisableDelete, setIsDisableDelete] = useState(true)
  const [getIsAllowRead, setIsAllowRead] = useState(false)
  const [getAccessLoading, setAccessLoading] = useState(true)
  const [getRights, setRights] = useState([])
  const [getPermissions, setPermissions] = useState([])
  const [selType, setSelType] = React.useState(2)
  const [isActive, setIsActive] = React.useState(false)
  const [getCurrData, setCurrData] = useState({
    currencyCode: '',
    currencySymbol: ''
  })
  const [checkedList, setCheckedList] = React.useState()

  React.useEffect(() => {
    if (!checkIsWeb().exist) {
      postDataToApp(PostAppTypes.PAGE_HEADER, 'printers.setup.screen')
    }
    dispatch(setCommonConfigs(PRINTING))
  }, [])

  //for common data -> store currency
  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      const commonData = getReduxCommonSetting
      const respData =
        commonData &&
        commonData.storeCommonConfigs &&
        commonData.storeCommonConfigs.storeConfig
          ? commonData.storeCommonConfigs.storeConfig
          : {}
      if (respData && respData.currencyData) {
        let currencyData = respData.currencyData
        setCurrData(currencyData)
      }
      // rights && permissions
      if (commonData && commonData.storeCommonConfigs) {
        const rpData = checkRightspermissions(commonData)
        if (rpData && !isEmptyObject(rpData)) {
          setupRightsPermissions(rpData)
          setAccessLoading(false)
        } else {
          toInitialState()
          setAccessLoading(false)
        }
      }
    }

    return () => (mounted = false)
  }, [getReduxCommonSetting])

  React.useEffect(() => {
    handleChange()
    const unsub = store.subscribe(handleChange)
    getPrintListing(getPagination)

    return () => {
      unsub()
    }
  }, [loadDataState])

  function toInitialState () {
    setRights([])
    setPermissions([])
    setIsAllowRead(false)
    setIsDisableCreate(true)
    setIsDisableUpdate(true)
    setIsDisableDelete(true)
    setAccessLoading(true)
  }

  function setupRightsPermissions (rpData) {
    if (rpData.rights && rpData.rights.length > 0) {
      setRights(rpData.rights)
    } else {
      setRights([])
    }
    if (rpData.permissions && rpData.permissions.length > 0) {
      setPermissions(rpData.permissions)
    } else {
      setPermissions([])
    }
    if (rpData.read) {
      setIsAllowRead(true)
    } else {
      setIsAllowRead(false)
    }
    if (rpData.create) {
      setIsDisableCreate(false)
    } else {
      setIsDisableCreate(true)
    }
    if (rpData.update) {
      setIsDisableUpdate(false)
    } else {
      setIsDisableUpdate(true)
    }
    if (rpData.delete) {
      setIsDisableDelete(false)
    } else {
      setIsDisableDelete(true)
    }
  }

  const onChange = list => {
    setCheckedList(list)
  }

  async function getPrintListing (body) {
    const req = ds.getPrintersService(body, BEHAVIOUR_TYPE.GET)
    await req
      .then(res => {
        if (res && res.length > 0) {
          let paginationobj = {
            CurrentPageNo: res[0].currentPageNo,
            PageSize: res[0].pageSize,
            total: res[0].totalRecords,
            showSizeChanger: true
          }
          // mapped.sort((a, b) => (a.createdon < b.createdon ? 1 : -1));
          setTableData(res)
          setPagination(paginationobj)
        }
        setIsLoading(false)
        setIsLoadingTable(false)
        setSpinningLoading(false)
        // if (loadDataState) {
        //   setloadDataState(false)
        // }
      })
      .catch(e => {
        notAllowMsgCheck(e)
        setIsLoading(false)
        setIsLoadingTable(false)
      })
  }

  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      render: text => {
        return (
          <span className='gx-link' style={{ fontWeight: '500' }}>
            {text}
          </span>
        )
      }
    },
    {
      title: 'Type',
      dataIndex: 'type',
      key: 'type',
      render: text => {
        const ttype =
          PRINTING_TYPE.filter(a => a.id == text) &&
          PRINTING_TYPE.filter(a => a.id == text).length > 0
            ? PRINTING_TYPE.filter(a => a.id == text)[0].name
            : ''
        return (
          <span className='' style={{ fontWeight: '500' }}>
            {ttype}
          </span>
        )
      }
    },
    {
      title: 'Title',
      dataIndex: 'header',
      key: 'header'
      //   render: (text, record) => {
      //     return (
      //       <div>
      //         <span>
      //          {record.numofproducts}
      //         </span>
      //       </div>
      //     );
      //   },
    },
    {
      title: 'Subtitle 1',
      dataIndex: 'subtitle1',
      key: 'subtitle1'
      //   render: (text, record) => {
      //     return (
      //       <div>
      //         <span>
      //          {record.numofproducts}
      //         </span>
      //       </div>
      //     );
      //   },
    },
    {
      title: 'Subtitle 2',
      dataIndex: 'subtitle2',
      key: 'subtitle2'
      //   render: (text, record) => {
      //     return (
      //       <div>
      //         <span>
      //          {record.numofproducts}
      //         </span>
      //       </div>
      //     );
      //   },
    },
    {
      title: 'Footer',
      dataIndex: 'footer',
      key: 'footer'
      //   render: (text, record) => {
      //     return (
      //       <div>
      //         <span>
      //          {record.numofproducts}
      //         </span>
      //       </div>
      //     );
      //   },
    },
    {
      title: 'IP',
      dataIndex: 'ip',
      key: 'ip'
      //   render: (text, record) => {
      //     return (
      //       <div>
      //         <span>
      //          {record.numofproducts}
      //         </span>
      //       </div>
      //     );
      //   },
    },
    {
      title: 'Port',
      dataIndex: 'port',
      key: 'port'
      // render: (text, record) => {
      //   //const [form] = Form.useForm();
      //   const viewProduct = async printerID => {
      //     history.push(`/dashboard/products/main/listing/brandid/${printerID}`)
      //   }
      //   return (
      //     <div>
      //       <span>
      //         <a
      //           onClick={() => viewProduct(record.key)}
      //           className='gx-icon-text'
      //         >
      //           View Product
      //         </a>
      //       </span>
      //     </div>
      //   )
      // }
    },
    {
      title: 'IsActive',
      dataIndex: 'isActive',
      key: 'active',
      render: (text, record) => {
        return (
          <span
            className={record.isActive ? 'gx-link' : ''}
            style={{ fontWeight: '500' }}
          >
            {record.isActive ? 'Active' : 'Not Active'}
          </span>
        )
      }
    },
    {
      title: <IntlMessages id='products.brands.edit' />,
      key: 'edit',
      render: (text, record) => {
        //const [form] = Form.useForm();
        const editPrinter = (
          printerID,
          name,
          type,
          ip,
          port,
          isActive,
          header,
          subtitle1,
          subtitle2,
          footer
        ) => {
          setVisible(true)
          // message.success("Successfully Done Product Brand");
          setSelType(type ? type : 1)
          setIsActive(isActive ? true : false)
          setPrintID(printerID)
          form.setFieldsValue({ PrintName: name })
          form.setFieldsValue({ IP: ip })
          form.setFieldsValue({ PORT: port })
          form.setFieldsValue({ header: header })
          form.setFieldsValue({ subtitle1: subtitle1 })
          form.setFieldsValue({ subtitle2: subtitle2 })
          form.setFieldsValue({ footer: footer })
        }
        return getIsDisableUpdate ? (
          <Tag color='#f50'>
            <strong>
              <IntlMessages id='dakarpos.allow.accessdenied' />
            </strong>
          </Tag>
        ) : (
          <div>
            <span>
              <a
                onClick={() => {
                  const checked = []
                  if (record.showDatetime) {
                    checked.push(PrintCheckDatetime)
                  }
                  if (record.showServedBy) {
                    checked.push(PrintCheckServedBy)
                  }
                  if (record.showOutlet) {
                    checked.push(PrintCheckOutlet)
                  }
                  if (record.showRegister) {
                    checked.push(PrintCheckRegister)
                  }
                  if (record.showHeader) {
                    checked.push(PrintShowHeader)
                  }
                  if (record.showFooter) {
                    checked.push(PrintShowFooter)
                  }
                  if (record.showPrinterProds) {
                    checked.push(ShowPrinterProds)
                  }
                  setCheckedList(checked)
                  editPrinter(
                    record.printerID,
                    record.name,
                    record.type,
                    record.ip,
                    record.port,
                    record.isActive,
                    record.header,
                    record.subtitle1,
                    record.subtitle2,
                    record.footer
                  )
                }}
                className='pen-edit'
              >
                <i className='icon icon-edit' />
              </a>
            </span>
          </div>
        )
      }
    },
    {
      title: <IntlMessages id='products.brands.delete' />,
      key: 'delete',
      render: (text, record) => {
        const deleteBrands = async printerID => {
          setSpinningLoading(true)
          if (printerID) {
            await ds
              .postPrintersService(
                {
                  PrinterID: printerID,
                  Behavior: 2
                },
                BEHAVIOUR_TYPE.DELETE
              )
              .then(response => {
                setSpinningLoading(false)
                if (response) {
                  setTableData(
                    getTableData.filter(a => a.printerID !== printerID)
                  )
                  message.success('Successfully deleted')
                } else message.error('Check connection and try again')
              })
              .catch(e => {
                setSpinningLoading(false)
                notAllowMsgCheck(e)
              })
          } else message.error('Failed, check connection and try again')
        }

        function showDeleteConfirm (printerID, printerName) {
          confirm({
            title: 'Are you sure delete this Printer?',
            content: `"${printerName}"`,
            okText: 'Yes',
      cancelText: 'No',
      okButtonProps:{className: 'dk-btn-add close-reg-btn'},
      cancelButtonProps: {className: "dk-btn-cancel close-reg-btn"},
            onOk () {
              deleteBrands(printerID)
            },
            onCancel () {
              //console.log('Cancel');
            }
          })
        }

        return getIsDisableDelete ? (
          <Tag color='#f50'>
            <strong>
              <IntlMessages id='dakarpos.allow.accessdenied' />
            </strong>
          </Tag>
        ) : (
          <span
            style={{
              // display: 'flex',
              // placeContent: 'center',
              marginLeft: 18,
              fontSize: 'large'
            }}
          >
            <a
              onClick={() => showDeleteConfirm(record.printerID, record.name)}
              style={{ color: 'red' }}
            >
              <i className='icon icon-trash' />
            </a>
          </span>
        )
      }
    }
  ]
  const handleOk = () => {
    setConfirmLoading(true)
    //this.setState({ confirmLoading: true })
    setTimeout(() => {
      setConfirmLoading(false)
      setVisible(false)
      //this.setState({ confirmLoading: false, visible: false })
    }, 2000)
  }
  const handleCancel = () => {
    //props['IsShow'] = false;
    setVisible(false)
    setPrintID(0)
    //this.setState({ visible: false })
  }
  const onFinishFailed = errorInfo => {
    message.error('Kindly attend to the wrong Input')
  }
  const onFinish = async values => {
    setVisible(false)
    setSpinningLoading(true)
    if (values && values.PrintName) {
      await ds
        .postPrintersService(
          {
            Behavior: 3,
            PrinterID: getPrintID,
            Name: values.PrintName,
            IP: values.IP,
            Port: values.PORT,
            IsActive: isActive ? true : false,
            Type: selType,
            Header: values.header ? values.header : '',
            Subtitle1: values.subtitle1 ? values.subtitle1 : '',
            Subtitle2: values.subtitle2 ? values.subtitle2 : '',
            ShowOutlet:
              checkedList &&
              checkedList.length > 0 &&
              checkedList.filter(a => a == PrintCheckOutlet).length > 0
                ? true
                : false,
            ShowRegister:
              checkedList &&
              checkedList.length > 0 &&
              checkedList.filter(a => a == PrintCheckRegister).length > 0
                ? true
                : false,
            ShowDatetime:
              checkedList &&
              checkedList.length > 0 &&
              checkedList.filter(a => a == PrintCheckDatetime).length > 0
                ? true
                : false,
            ShowServedBy:
              checkedList &&
              checkedList.length > 0 &&
              checkedList.filter(a => a == PrintCheckServedBy).length > 0
                ? true
                : false,
            ShowPrinterProds:
              checkedList &&
              checkedList.length > 0 &&
              checkedList.filter(a => a == PrintCheckServedBy).length > 0
                ? true
                : false,
            ShowPrinterProds:
              checkedList &&
              checkedList.length > 0 &&
              checkedList.filter(a => a == ShowPrinterProds).length > 0
                ? true
                : false,
            ShowHeader:
              checkedList &&
              checkedList.length > 0 &&
              checkedList.filter(a => a == PrintShowHeader).length > 0
                ? true
                : false,
            ShowFooter:
              checkedList &&
              checkedList.length > 0 &&
              checkedList.filter(a => a == PrintShowFooter).length > 0
                ? true
                : false,
            IsTabletPrinter: false,
            Footer: values.footer ? values.footer : ''
          },
          BEHAVIOUR_TYPE.POST
        )
        .then(response => {
          if (response) {
            form.resetFields()
            setCheckedList([])
            dispatch(loadData(true))
            message.success('Successfully Updated')
          } else message.error('Check conection & Try Again')
          setSpinningLoading(false)
        })
        .catch(e => {
          message.error('Something went wrong')
          setSpinningLoading(false)
          notAllowMsgCheck(e)
        })
    } else message.error('Kindly provide proper information')
  }

  function setTypeCheck (e) {
    if (e) {
      setSelType(e)
    }
  }
  const EditModal = () => {
    return (
      <div>
        <Modal
          width={402}
          bodyStyle={{ height: 500, overflowX: 'scroll' }}
          title={'Edit Printer'}
          visible={visible}
          onOk={handleOk}
          onCancel={handleCancel}
          centered={true}
          // width={'402px'}
          footer={null}
        >
          <Form
            {...formItemLayout}
            form={form}
            name='brandsEdit'
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            initialValues={{
              prefix: '86'
            }}
            scrollToFirstError
          >
            <Form.Item
              className='ant-form-item-label-custom ant-form-margin-right'
              name='PrintName'
              label={
                <span>
                  <strong>Printer Name</strong>
                  <Tooltip title='Name'></Tooltip>
                </span>
              }
              rules={[
                {
                  required: true,
                  message: 'Please enter Printer name',
                  whitespace: true
                }
              ]}
            >
              <Input placeholder='Printer Name' />
            </Form.Item>
            <Form.Item
              className='ant-form-item-label-custom ant-form-margin-right'
              // name='Type'
              label={
                <span>
                  <strong>Type</strong>
                  <Tooltip title='Type'></Tooltip>
                </span>
              }
              // rules={[
              //   {
              //     required: true,
              //     message: 'Please select Printer type',
              //     whitespace: true
              //   }
              // ]}
            >
              <Select
                size='large'
                onChange={e => setTypeCheck(e)}
                value={selType}
              >
                {PRINTING_TYPE.map((e, key) => {
                  return (
                    <Select.Option key={key} value={e.id} disabled={e.id == 1}>
                      {e.name}
                    </Select.Option>
                  )
                })}
              </Select>{' '}
            </Form.Item>
            <Form.Item
              className='ant-form-item-label-custom ant-form-margin-right'
              name='header'
              label={
                <span>
                  <strong>Title</strong>
                  <Tooltip title='Title to print'></Tooltip>
                </span>
              }
              // rules={[
              //   {
              //     required: true,
              //     message: 'Please enter Printer name',
              //     whitespace: true
              //   }
              // ]}
            >
              <Input placeholder='Print Title' />
            </Form.Item>
            <Form.Item
              className='ant-form-item-label-custom ant-form-margin-right'
              name='subtitle1'
              label={
                <span>
                  <strong>Subtitle 1</strong>
                  <Tooltip title='Subtitle 1 to print'></Tooltip>
                </span>
              }
              // rules={[
              //   {
              //     required: true,
              //     message: 'Please enter Printer name',
              //     whitespace: true
              //   }
              // ]}
            >
              <Input placeholder='Subtitle 1' />
            </Form.Item>
            <Form.Item
              className='ant-form-item-label-custom ant-form-margin-right'
              name='subtitle2'
              label={
                <span>
                  <strong>Subtitle 2</strong>
                  <Tooltip title='Subtitle 2 to print'></Tooltip>
                </span>
              }
              // rules={[
              //   {
              //     required: true,
              //     message: 'Please enter Printer name',
              //     whitespace: true
              //   }
              // ]}
            >
              <Input placeholder='Subtitle 2' />
            </Form.Item>
            <Form.Item
              className='ant-form-item-label-custom ant-form-margin-right'
              name='footer'
              label={
                <span>
                  <strong>Footer</strong>
                  <Tooltip title='Footer to print'></Tooltip>
                </span>
              }
              // rules={[
              //   {
              //     required: true,
              //     message: 'Please enter Printer name',
              //     whitespace: true
              //   }
              // ]}
            >
              <Input placeholder='Printer Footer' />
            </Form.Item>
            {selType && selType == 2 && (
              <>
                <Form.Item
                  className='ant-form-item-label-custom ant-form-margin-right'
                  name='IP'
                  label={
                    <span>
                      <strong>IP</strong>
                      <Tooltip title='IP'></Tooltip>
                    </span>
                  }
                >
                  <Input placeholder='IP' />
                </Form.Item>
                <Form.Item
                  className='ant-form-item-label-custom ant-form-margin-right'
                  name='PORT'
                  label={
                    <span>
                      <strong>PORT</strong>
                      <Tooltip title='PORT'></Tooltip>
                    </span>
                  }
                >
                  <Input placeholder='PORT' />
                </Form.Item>
              </>
            )}
            <Form.Item className='ant-form-item-label-custom ant-form-margin-right mt-12'>
              <CheckboxGroup
                options={plainOptions}
                value={checkedList}
                onChange={onChange}
              />
            </Form.Item>
            <Form.Item
              className='ant-form-item-label-custom ant-form-margin-right'
              // name='ACTIVE'
              label={
                <span>
                  <strong>Is Active</strong>
                  <Tooltip title='Is Active'></Tooltip>
                </span>
              }
            >
              <span>
                <a className='gx-link'>
                  <Switch
                    checked={isActive}
                    onChange={ev => {
                      setIsActive(ev)
                    }}
                  />
                </a>
              </span>
            </Form.Item>
            <Row style={{ marginRight: 0 }} justify='end'>
              <Col>
                <Button
                  className='dk-btn-add'
                  type='primary'
                  // block
                  htmlType='submit'
                >
                  Save
                </Button>
              </Col>
            </Row>
          </Form>
        </Modal>
      </div>
    )
  }

  const handleChange = () => {
    if (store.getState().settings.loadData != loadDataState) {
      setloadDataState(store.getState().settings.loadData)
      dispatch(loadData(false))
    }
  }

  const handleTableChange = (pagination, filters, sorter) => {
    setIsLoadingTable(true)
    var body = getPagination
    body.CurrentPageNo = pagination.current
    body.PageSize = pagination.pageSize
    getPrintListing(body)
  }

  return getIsAllowRead ? (
    <Spin
      tip={'Adding a Printer to Your Computer: A Simple Process for Users'}
      spinning={isSpinningLoading}
      size='large'
    >
      <div className='custom-content-wrapper'>
        <Row className='dk-flex-space-bw'>
          {checkIsWeb().exist && (
            <Col md={6}>
              <h1 className=''>
                <IntlMessages id='printers.setup.screen' />
              </h1>
            </Col>
          )}
          <Col md={checkIsWeb().exist ? 18 : 24}>
            <div style={{ textAlign: 'right', marginBottom: '16px' }}>
              {!getIsDisableCreate && <AddPrinters />}
            </div>
          </Col>
        </Row>

        <Card className='gx-card' title=''>
          <Collapse>
            <Panel
              className='custom-promolist-help'
              showArrow={false}
              header={<IntlMessages id='products.brands.needhelpheading' />}
            >
              <Row>
                <div className='billing-main'>
                  <Col className='custom-promolist-helpdesc' md={12}>
                    <p>
                      Adding a printer to your computer is a simple process that
                      allows you to start printing documents, photos, and other
                      materials in no time. Whether you're using a Windows PC or
                      a Mac, there are several ways to add a printer, including
                      through a wired or wireless connection.
                    </p>
                    <p>
                      With the right steps and tools, you can get your printer
                      up and running in just a few minutes, enabling you to
                      produce high-quality prints for your home or office needs.
                      In this guide, we'll explore the various methods for
                      adding a printer and help you find the one that works best
                      for your device and printer model.
                    </p>
                  </Col>

                  <Col md={12}>
                    <img src={ProductBrandPic} alt='' />
                  </Col>
                </div>
              </Row>
            </Panel>
          </Collapse>
        </Card>

        <div>
          <Card style={{ marginTop: -10 }}>
            {isLoading ? (
              <Skeleton count={7} height={35} />
            ) : (
              <Table
                className='gx-table-responsive'
                loading={isLoadingTable}
                columns={columns}
                dataSource={getTableData}
                pagination={getPagination}
                onChange={handleTableChange}
                // rowKey={(record) => record.key}
              />
            )}
            <EditModal />
          </Card>
        </div>
      </div>
    </Spin>
  ) : (
    <NotAllowedComponent getAccessLoading={getAccessLoading} textType={1} />
  )
}

export default PrintListing
